<template>
  <div class="">

    <b-button class="food-comment-btn mt-1 col-lg-8  border-0" v-b-toggle="'product-comment-'+commentable.id" pill
              @click="getComments(commentable)">نظرات
    </b-button>

    <show-comments-on-side :comments="comments" :commentable_type="commentable_type" :commentable_id="commentable.id"
                           :commentable_name="commentable.name"/>

  </div>
</template>

<script>
import ShowCommentsOnSide from './ShowCommentsOnSide';
import {mapGetters} from 'vuex';

export default {
  name: "CommentButton",
  components: {ShowCommentsOnSide},
  props: {
    commentable: {
      type: Object,
      required: true
    },
    commentable_type: {
      type: String,
    }
  },
  computed: {
    ...mapGetters({
      comments: 'Comment/getProductComments'
    })
  },
  methods: {
    getComments(commentable) {
      let form = {id: commentable.id, comment_type: this.commentable_type}
      this.$store.dispatch("Comment/getClientComments", {form: form})
    },
  }
}
</script>

<style scoped>

</style>